"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCoverageLayerDays = exports.getAllLayerDays = exports.parseLayerDays = exports.parseSupportedFormats = exports.parseDates = exports.findAndParseCoverage = exports.parseCoverage = exports.fetchCoverageDescriptionFromCapabilities = exports.createDescribeCoverageUrl = exports.createGetCoverageUrl = exports.findGetCoverageUrl = exports.findDescribeCoverageUrl = exports.findCoverageOpUrl = exports.findAndParseExtent = exports.findAndParseLonLatEnvelope = exports.findCoverageSubType = exports.findLayerIds = exports.findCoverageDisplayNames = exports.findCoverage = exports.findCoverageDisplayName = exports.findCoverageLabel = exports.findCoverageTitle = exports.findLayerDescription = exports.findCoverageDescription = exports.findCoverageAbstract = exports.findLayerId = exports.findCoverageName = exports.findCoverageId = exports.findCoverageIdentifier = exports.normalizeCoverageId = exports.findCoverages = void 0;
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var xml_utils_1 = require("xml-utils");
var gml_1 = require("../../gml");
var utils_1 = require("../../utils");
var ows_1 = require("../../ows");
function findCoverages(xml) {
    var tagNames = [
        "wcs:CoverageOfferingBrief",
        "CoverageOfferingBrief",
        "wcs:CoverageSummary",
    ];
    // eslint-disable-next-line fp/no-mutation
    for (var i = 0; i < tagNames.length; i += 1) {
        var tagName = tagNames[i];
        if (xml.includes(tagName)) {
            return (0, xml_utils_1.findTagsByName)(xml, tagName).map(function (tag) { return tag.outer; });
        }
    }
    return [];
}
exports.findCoverages = findCoverages;
function normalizeCoverageId(id) {
    return id.replace("__", ":");
}
exports.normalizeCoverageId = normalizeCoverageId;
function findCoverageIdentifier(xml) {
    return (0, utils_1.findTagText)(xml, "wcs:Identifier");
}
exports.findCoverageIdentifier = findCoverageIdentifier;
function findCoverageId(xml) {
    return (0, utils_1.findTagText)(xml, "wcs:CoverageId");
}
exports.findCoverageId = findCoverageId;
function findCoverageName(xml) {
    return (0, utils_1.findTagText)(xml, "name") || (0, utils_1.findTagText)(xml, "wcs:name");
}
exports.findCoverageName = findCoverageName;
function findLayerId(xml, _a) {
    var _b = _a === void 0 ? { normalize: true } : _a, _c = _b.normalize, normalize = _c === void 0 ? true : _c;
    // version 2.x
    var coverageId = findCoverageId(xml);
    if (coverageId) {
        return normalize ? normalizeCoverageId(coverageId) : coverageId;
    }
    // version 1.1.x
    var identifier = findCoverageIdentifier(xml);
    if (identifier) {
        return identifier;
    }
    // version 1.0
    var name = findCoverageName(xml);
    if (name) {
        return name;
    }
    throw new Error("unable to find coverage id");
}
exports.findLayerId = findLayerId;
function findCoverageAbstract(xml) {
    return (0, utils_1.findTagText)(xml, "ows:Abstract");
}
exports.findCoverageAbstract = findCoverageAbstract;
function findCoverageDescription(xml) {
    return (0, utils_1.findTagText)(xml, "description");
}
exports.findCoverageDescription = findCoverageDescription;
function findLayerDescription(xml) {
    return findCoverageAbstract(xml) || findCoverageDescription(xml);
}
exports.findLayerDescription = findLayerDescription;
function findCoverageTitle(xml) {
    return (0, utils_1.findTagText)(xml, "ows:Title");
}
exports.findCoverageTitle = findCoverageTitle;
function findCoverageLabel(xml) {
    return (0, utils_1.findTagText)(xml, "label");
}
exports.findCoverageLabel = findCoverageLabel;
function findCoverageDisplayName(xml) {
    return findCoverageTitle(xml) || findCoverageLabel(xml);
}
exports.findCoverageDisplayName = findCoverageDisplayName;
function findCoverage(xml, layerIdOrName) {
    var normalized = normalizeCoverageId(layerIdOrName);
    return findCoverages(xml).find(function (layer) {
        return findLayerId(layer, { normalize: true }) === normalized ||
            findCoverageDisplayName(layer) === layerIdOrName;
    });
}
exports.findCoverage = findCoverage;
function findCoverageDisplayNames(xml) {
    var coverages = findCoverages(xml);
    var displayNames = coverages.map(function (coverage) {
        return findCoverageDisplayName(coverage);
    });
    return displayNames.filter(function (name) { return name !== undefined; }).map(function (name) { return name; });
}
exports.findCoverageDisplayNames = findCoverageDisplayNames;
function findLayerIds(xml, _a) {
    var _b = _a === void 0 ? {} : _a, normalize = _b.normalize;
    return findCoverages(xml).map(function (layer) { return findLayerId(layer, { normalize: normalize }); });
}
exports.findLayerIds = findLayerIds;
function findCoverageSubType(xml) {
    return (0, utils_1.findTagText)(xml, "wcs:CoverageSubtype");
}
exports.findCoverageSubType = findCoverageSubType;
function findAndParseLonLatEnvelope(xml) {
    var envelope = (0, utils_1.findTagText)(xml, "lonLatEnvelope");
    if (!envelope) {
        return undefined;
    }
    var _a = __read((0, xml_utils_1.findTagsByName)(envelope, "gml:pos"), 2), lowerCorner = _a[0], upperCorner = _a[1];
    if ((lowerCorner === null || lowerCorner === void 0 ? void 0 : lowerCorner.inner) && (upperCorner === null || upperCorner === void 0 ? void 0 : upperCorner.inner)) {
        var _b = __read(lowerCorner.inner
            .split(" ")
            .map(function (str) { return Number(str); }), 2), west = _b[0], south = _b[1];
        var _c = __read(upperCorner.inner
            .split(" ")
            .map(function (str) { return Number(str); }), 2), east = _c[0], north = _c[1];
        return [west, south, east, north];
    }
    return undefined;
}
exports.findAndParseLonLatEnvelope = findAndParseLonLatEnvelope;
// for CoverageDescription
function findAndParseExtent(xml) {
    return findAndParseLonLatEnvelope(xml) || (0, gml_1.findAndParseEnvelope)(xml);
}
exports.findAndParseExtent = findAndParseExtent;
function findCoverageOpUrl(xml, op) {
    return ((0, utils_1.findAndParseCapabilityUrl)(xml, op) || (0, ows_1.findAndParseOperationUrl)(xml, op));
}
exports.findCoverageOpUrl = findCoverageOpUrl;
function findDescribeCoverageUrl(xml) {
    return findCoverageOpUrl(xml, "DescribeCoverage");
}
exports.findDescribeCoverageUrl = findDescribeCoverageUrl;
function findGetCoverageUrl(xml) {
    return findCoverageOpUrl(xml, "GetCoverage");
}
exports.findGetCoverageUrl = findGetCoverageUrl;
function createGetCoverageUrl(_a) {
    var bbox = _a.bbox, bboxDigits = _a.bboxDigits, capabilities = _a.capabilities, _b = _a.checkExtent, doCheckExtent = _b === void 0 ? true : _b, _c = _a.crs, crs = _c === void 0 ? "EPSG:4326" : _c, date = _a.date, _d = _a.format, format = _d === void 0 ? "GeoTIFF" : _d, givenHeight = _a.height, layerId = _a.layerId, _e = _a.maxPixels, maxPixels = _e === void 0 ? 5096 : _e, _f = _a.needExtent, needExtent = _f === void 0 ? false : _f, _g = _a.resolution, resolution = _g === void 0 ? 256 : _g, url = _a.url, _h = _a.version, version = _h === void 0 ? "1.0.0" : _h, givenWidth = _a.width;
    var base = (function () {
        if (url) {
            return url;
        }
        if (capabilities) {
            return findGetCoverageUrl(capabilities);
        }
        return undefined;
    })();
    if (!base) {
        throw new Error("failed to create DescribeCoverage Url");
    }
    if (needExtent && !bbox) {
        throw new Error("no extent provided to createGetCoverageUrl");
    }
    if (doCheckExtent) {
        (0, utils_1.checkExtent)(bbox);
    }
    var _j = (function () {
        if ((typeof givenHeight !== "number" && typeof givenWidth !== "number") ||
            givenHeight > maxPixels ||
            givenWidth > maxPixels) {
            return (0, utils_1.scaleImage)(bbox, { maxPixels: maxPixels, resolution: resolution });
        }
        return { height: givenHeight, width: givenWidth };
    })(), height = _j.height, width = _j.width;
    var time = date ? (0, moment_1.default)(date).format(utils_1.DEFAULT_DATE_FORMAT) : undefined;
    if (version.startsWith("0") || version.startsWith("1")) {
        return (0, utils_1.formatUrl)(base, {
            bbox: (0, utils_1.bboxToString)(bbox, bboxDigits),
            coverage: layerId,
            crs: crs,
            format: format,
            height: height,
            request: "GetCoverage",
            service: "WCS",
            time: time,
            version: version,
            width: width,
        });
    }
    if (version.startsWith("2")) {
        // Subsets are used as spatial and temporal filters.
        // For more info: https://docs.geoserver.geo-solutions.it/edu/en/wcs/get.html
        var spatialSubsets = (function () {
            if (bbox) {
                var _a = __read(bbox, 4), xmin = _a[0], ymin = _a[1], xmax = _a[2], ymax = _a[3];
                return ["Long(".concat(xmin, ",").concat(xmax, ")"), "Lat(".concat(ymin, ",").concat(ymax, ")")];
            }
            return [];
        })();
        var temporalSubsets = time ? ["time(\"".concat(time, "\")")] : [];
        var subsets = __spreadArray(__spreadArray([], __read(spatialSubsets), false), __read(temporalSubsets), false);
        var formattedUrl = (0, utils_1.formatUrl)(base, {
            format: format,
            coverageId: layerId,
            height: height,
            outputCRS: crs,
            request: "GetCoverage",
            service: "WCS",
            width: width,
        });
        var formattedSubsets = subsets.map(function (s) { return "subset=".concat(s); }).join("&");
        return "".concat(formattedUrl, "&").concat(formattedSubsets);
    }
    throw new Error("[prism-common] createGetCoverageUrl was called with an unexpected version");
}
exports.createGetCoverageUrl = createGetCoverageUrl;
function createDescribeCoverageUrl(xml, layerId) {
    var _a;
    var base = findDescribeCoverageUrl(xml);
    if (!base) {
        throw new Error("failed to create DescribeCoverage Url");
    }
    var version = (0, utils_1.findVersion)(xml);
    var layerParamName = (function () {
        if (version.startsWith("1.1")) {
            return "identifiers";
        }
        if (version.startsWith("0") || version.startsWith("1")) {
            return "coverage";
        }
        return "coverageId";
    })();
    return (0, utils_1.formatUrl)(base, (_a = {},
        _a[layerParamName] = layerId,
        _a.request = "DescribeCoverage",
        _a.service = "WCS",
        _a.version = version,
        _a));
}
exports.createDescribeCoverageUrl = createDescribeCoverageUrl;
function fetchCoverageDescriptionFromCapabilities(capabilities, layerId, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var run;
        var _this = this;
        return __generator(this, function (_a) {
            run = function () { return __awaiter(_this, void 0, void 0, function () {
                var url, response, text, exception;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = createDescribeCoverageUrl(capabilities, layerId);
                            return [4 /*yield*/, (options.fetch || fetch)(url)];
                        case 1:
                            response = _a.sent();
                            if (response.status !== 200) {
                                throw new Error("failed to fetch CoverageDescription from \"".concat(url, "\". status was ").concat(response.status));
                            }
                            return [4 /*yield*/, response.text()];
                        case 2:
                            text = _a.sent();
                            exception = (0, ows_1.findException)(text);
                            if (exception) {
                                throw new Error("couldn't fetch coverage description because of the following error:\n".concat(exception));
                            }
                            return [2 /*return*/, text];
                    }
                });
            }); };
            return [2 /*return*/, (0, utils_1.setTimeoutAsync)(options.wait || 0, run)];
        });
    });
}
exports.fetchCoverageDescriptionFromCapabilities = fetchCoverageDescriptionFromCapabilities;
function parseCoverage(xml) {
    return {
        id: findLayerId(xml),
        name: findCoverageDisplayName(xml),
        description: findLayerDescription(xml),
        keywords: (0, ows_1.findAndParseKeywords)(xml),
        bbox: (0, ows_1.findAndParseBoundingBox)(xml),
        wgs84bbox: (0, ows_1.findAndParseWGS84BoundingBox)(xml) || findAndParseLonLatEnvelope(xml),
        subType: findCoverageSubType(xml),
    };
}
exports.parseCoverage = parseCoverage;
function findAndParseCoverage(xml, layerIdOrName) {
    var coverage = findCoverage(xml, layerIdOrName);
    return coverage ? parseCoverage(coverage) : undefined;
}
exports.findAndParseCoverage = findAndParseCoverage;
function parseDates(description) {
    var timePositions = (0, utils_1.findTagArray)(description, [
        "domainSet",
        "temporalDomain",
        "gml:timePosition",
    ]);
    if (timePositions.length > 0) {
        return timePositions;
    }
    return (0, utils_1.findTagArray)(description, ["lonLatEnvelope", "gml:timePosition"]);
}
exports.parseDates = parseDates;
function parseSupportedFormats(xml) {
    return (0, utils_1.findTagArray)(xml, ["supportedFormats", "formats"]);
}
exports.parseSupportedFormats = parseSupportedFormats;
function parseLayerDays(xml) {
    var dateStrings = parseDates(xml);
    // round to noon to avoid errors due to daylight saving
    var days = dateStrings.map(utils_1.setNoon);
    var uniqueDays = (0, lodash_1.uniq)(days);
    return uniqueDays.map(function (date) { return new Date(date).getTime(); });
}
exports.parseLayerDays = parseLayerDays;
function getAllLayerDays(xml) {
    var layers = findCoverages(xml);
    var allDays = {};
    layers.forEach(function (layer) {
        var layerId = findLayerId(layer);
        if (layerId) {
            var oldLayerDays = allDays[layerId] || [];
            var layerDays = parseLayerDays(layer);
            allDays[layerId] = (0, lodash_1.union)(layerDays, oldLayerDays);
        }
    });
    return allDays;
}
exports.getAllLayerDays = getAllLayerDays;
function fetchCoverageLayerDays(url, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.errorStrategy, errorStrategy = _c === void 0 ? "throw" : _c, fetch = _b.fetch;
    return __awaiter(this, void 0, void 0, function () {
        var capabilities, error_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, ows_1.getCapabilities)(url, {
                            fetch: fetch,
                            version: "1.0.0",
                        })];
                case 1:
                    capabilities = _d.sent();
                    return [2 /*return*/, getAllLayerDays(capabilities)];
                case 2:
                    error_1 = _d.sent();
                    if (errorStrategy === "empty") {
                        return [2 /*return*/, {}];
                    }
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.fetchCoverageLayerDays = fetchCoverageLayerDays;
